import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { useRef, useState } from "react";
import { useQuery } from "react-query";
import { useMountedState } from "~/services/utils/hooks";
import { getWebinar } from "../../api";
import { useSession } from "../../contexts/Session";
import useWebsocket from "../useWebsocket";
import { useOnAirPaths } from "../useOnAirPaths";
var getRefreshIntervalTime = function(param) {
    var isUserRegistered = param.isUserRegistered, shouldUseWebsocket = param.shouldUseWebsocket, isWSConnected = param.isWSConnected;
    if (isUserRegistered) {
        if (shouldUseWebsocket) {
            return isWSConnected ? 60000 : 15000;
        }
        return 60000;
    }
    return 0;
};
var useWebinar = function(param) {
    var onMessage = param.onMessage, isViewerCountEnabled = param.isViewerCountEnabled, shouldUseWebsocket = param.shouldUseWebsocket, webinarId = param.webinarId;
    var ref = useSession(), query = ref.query, requestOptions = ref.requestOptions, sessionRegistrationId = ref.sessionRegistrationId;
    var subscribeWs = useOnAirPaths().subscribeWs;
    var ref1 = useState(false), isWSConnected = ref1[0], setIsWsConnected = ref1[1];
    var isMounted = useMountedState();
    var websocketHeartbeatData = useRef({
        streamId: undefined
    });
    var getSocket = useWebsocket({
        enabled: shouldUseWebsocket,
        isViewerCountEnabled: isViewerCountEnabled,
        sessionRegistrationId: sessionRegistrationId,
        url: "".concat(subscribeWs, "/").concat(webinarId, "/status").concat(query),
        heartbeatData: websocketHeartbeatData.current,
        onMessage: function(data) {
            onMessage(data);
        },
        onOpen: function() {
            if (isMounted()) {
                setIsWsConnected(true);
            }
        },
        onClose: function() {
            if (isMounted()) {
                setIsWsConnected(false);
            }
        }
    }).getSocket;
    var refetch = useQuery({
        queryKey: [
            "webinar",
            webinarId
        ],
        queryFn: /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    getWebinar({
                        id: webinarId
                    }, requestOptions)
                ];
            });
        }),
        refetchIntervalInBackground: true,
        refetchInterval: function(data) {
            return getRefreshIntervalTime({
                isWSConnected: isWSConnected,
                shouldUseWebsocket: shouldUseWebsocket,
                isUserRegistered: data === null || data === void 0 ? void 0 : data.isUserRegistered
            });
        },
        onSuccess: function(data) {
            onMessage(data);
            // Update the our websocket heartbeat data with the current stream ID
            websocketHeartbeatData.current.streamId = data.streamId;
        }
    }).refetch;
    return {
        getSocket: getSocket,
        refetch: refetch
    };
};
export default useWebinar;
